/* import __COLOCATED_TEMPLATE__ from './invite-button-entry.hbs'; */
import type AuthenticatorService from 'codecrafters-frontend/services/authenticator';
import Component from '@glimmer/component';
import { service } from '@ember/service';

export interface Signature {
  Element: HTMLDivElement;

  Args: {
    isCollapsed: boolean;
    text: string;
  };
}

export default class CourseLeaderboardInviteButtonEntry extends Component<Signature> {
  @service declare authenticator: AuthenticatorService;
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'CourseLeaderboard::InviteButtonEntry': typeof CourseLeaderboardInviteButtonEntry;
  }
}
